import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import "./game.css";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { GetCountry, GetImage, GetDate } from "../../funcUtils";

function Lottery() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [profile, setProfile] = useState(null);
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const date0 = new Date();
    const currentHour = date0.getHours();
    
    const [dateMT, setDateMT] = useState(date0.getDay());
    const [dataMT, setDataMT] = useState();
    const [imageMT, setImageMT] = useState([]);
    
    const [dateMN, setDateMN] = useState(date0.getDay());
    const [dataMN, setDataMN] = useState([]);
    const [imageMN, setImageMN] = useState([]);
    
    const [activeOption, setActiveOption] = useState("0");
    const handleOptionClick = (option) => {
        setActiveOption(option);
    };

    const [activeOption1, setActiveOption1] = useState(date0.getDay());
    const handleOptionClick1 = (option) => {
        setActiveOption1(option);
        setDateMT(option);
    };

    const [activeOption2, setActiveOption2] = useState(date0.getDay());
    const handleOptionClick2 = (option) => {
        setActiveOption2(option);
        setDateMN(option);
    };

    useEffect(() => {
        if (dateMT === 0) {
            if (currentHour < 18) {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            } else {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            }
        }
        if (dateMT === 1) {
            if (currentHour < 18) {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            } else {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            }
        }
        if (dateMT === 2) {
            if (currentHour < 18) {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            } else {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            }
        }
        if (dateMT === 3) {
            if (currentHour < 18) {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            } else {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            }
        }
        if (dateMT === 4) {
            if (currentHour < 18) {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            } else {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            }
        }
        if (dateMT === 5) {
            if (currentHour < 18) {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            } else {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            }
        }
        if (dateMT === 6) {
            if (currentHour < 18) {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            } else {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            }
        }
    }, [dateMT, currentHour]);

    useEffect(() => {
        if (dateMN === 0) {
            if (currentHour < 17) {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            } else {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            }
        }
        if (dateMN === 1) {
            if (currentHour < 17) {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            } else {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            }
        }
        if (dateMN === 2) {
            if (currentHour < 17) {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            } else {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            }
        }
        if (dateMN === 3) {
            if (currentHour < 17) {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            } else {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            }
        }
        if (dateMN === 4) {
            if (currentHour < 17) {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            } else {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            }
        }
        if (dateMN === 5) {
            if (currentHour < 17) {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            } else {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            }
        }
        if (dateMN === 6) {
            if (currentHour < 17) {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            } else {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            }
        }
    }, [dateMN, currentHour]);

    return (
        <>
            <Header profile={profile} />
            
            <style>{`
                .lottery-page-wrapper {
                    background-color: #1b1e36;
                    min-height: 80vh;
                    font-family: Arial, sans-serif;
                    padding-bottom: 50px;
                }
                .lottery-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 20px;
                }

                /* Thanh Menu Chính (Vùng Xổ Số) */
                .category-nav-bar {
                    background: linear-gradient(to right, #4de6ad, #65eed4);
                    border-radius: 12px;
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    overflow-x: auto;
                    margin-bottom: 25px;
                    scrollbar-width: none;
                }
                .category-nav-bar::-webkit-scrollbar {
                    display: none; 
                }
                .category-btn {
                    background-color: #1b684c;
                    border: none;
                    border-radius: 8px;
                    padding: 10px 20px;
                    height: 55px;
                    min-width: 150px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    flex-shrink: 0;
                    color: white;
                    font-weight: bold;
                    font-size: 16px;
                }
                .category-btn img {
                    height: 24px;
                    object-fit: contain;
                }
                .category-btn:hover {
                    background-color: #14503a;
                }
                .category-btn.active {
                    box-shadow: 0 0 0 3px #fff, 0 0 0 5px #ffde00; 
                    transform: scale(1.02);
                }

                /* Thanh Menu Phụ (Chọn Thứ) */
                .day-nav-bar {
                    display: flex;
                    gap: 10px;
                    overflow-x: auto;
                    margin-bottom: 25px;
                    padding-bottom: 5px;
                    scrollbar-width: none;
                }
                .day-nav-bar::-webkit-scrollbar { display: none; }
                .day-btn {
                    background: #e5f9f3;
                    border: 1px solid #7fe5c5;
                    color: #1b684c;
                    border-radius: 20px;
                    padding: 8px 20px;
                    font-weight: 600;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: all 0.2s;
                }
                .day-btn:hover {
                    background: #d1f4ec;
                }
                .day-btn.active {
                    background: #1b684c;
                    color: #fff;
                    border-color: #1b684c;
                    box-shadow: 0 4px 6px rgba(27, 104, 76, 0.3);
                }

                /* Lưới Game (Card Xổ Số) */
                .lottery-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
                    gap: 20px;
                }
                .lottery-card {
                    background: #1b1e36;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
                    transition: transform 0.3s, box-shadow 0.3s;
                    display: flex;
                    flex-direction: column;
                    cursor: pointer;
                    border: 1px solid #eee;
                }
                .lottery-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 15px rgba(0,0,0,0.15);
                    border-color: #5df0b1;
                }
                .lottery-img {
                    height: 270px;
                    width: 100%;
                    object-fit: cover;
                    background: #232845;
                }
                .lottery-info {
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 12px;
                }
                .lottery-title {
                    font-size: 16px;
                    font-weight: bold;
                    color: #0b7a65;
                    text-align: center;
                }
                .play-btn {
                    background: linear-gradient(90deg, #1fa270, #4bdc99);
                    width: 100%;
                    padding: 10px;
                    border-radius: 25px;
                    color: white;
                    font-weight: bold;
                    text-align: center;
                    border: none;
                    transition: 0.2s;
                }
                .play-btn:hover {
                    filter: brightness(1.1);
                    box-shadow: 0 4px 8px rgba(31, 162, 112, 0.4);
                }

                @media (max-width: 768px) {
                    .lottery-grid {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 15px;
                    }
                    .category-btn {
                        min-width: 130px;
                        font-size: 14px;
                    }
                    .lottery-img {
                        height: 120px;
                    }
                }
            `}</style>

            {loading === true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}

            <div className="lottery-page-wrapper">
                <div className="lottery-container">
                    
                    {/* 1. Thanh Chọn Vùng Xổ Số (Category) */}
                    <div className="category-nav-bar">
                        <button className={`category-btn ${activeOption === "0" ? "active" : ""}`} onClick={() => handleOptionClick("0")}>
                            <img src={require("../../image/common/north-hover.png")} alt="MB" />
                            Miền Bắc
                        </button>
                        <button className={`category-btn ${activeOption === "1" ? "active" : ""}`} onClick={() => handleOptionClick("1")}>
                            <img src={require("../../image/common/center-hover.png")} alt="MT" />
                            Miền Trung
                        </button>
                        <button className={`category-btn ${activeOption === "2" ? "active" : ""}`} onClick={() => handleOptionClick("2")}>
                            <img src={require("../../image/common/south-hover.png")} alt="MN" />
                            Miền Nam
                        </button>
                        <button className={`category-btn ${activeOption === "3" ? "active" : ""}`} onClick={() => handleOptionClick("3")}>
                            <img src={require("../../image/common/st-hover.png")} alt="ST" />
                            Siêu Tốc
                        </button>
                    </div>

                    {/* Nội Dung Từng Vùng */}
                    <div>
                        {/* MIỀN BẮC */}
                        {activeOption === "0" && (
                            <div className="lottery-grid">
                                <div className="lottery-card" onClick={() => navigate("/xsmb/lo2")}>
                                    <img className="lottery-img" src={require(`../../images/xs3mien/mienbac.png`)} alt="Miền Bắc" />
                                    <div className="lottery-info">
                                        <div className="lottery-title">Miền Bắc</div>
                                        <div className="play-btn">Vào trò chơi</div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* MIỀN TRUNG */}
                        {activeOption === "1" && (
                            <>
                                <div className="day-nav-bar">
                                    <button className={`day-btn ${activeOption1 === 1 ? "active" : ""}`} onClick={() => handleOptionClick1(1)}>Thứ 2</button>
                                    <button className={`day-btn ${activeOption1 === 2 ? "active" : ""}`} onClick={() => handleOptionClick1(2)}>Thứ 3</button>
                                    <button className={`day-btn ${activeOption1 === 3 ? "active" : ""}`} onClick={() => handleOptionClick1(3)}>Thứ 4</button>
                                    <button className={`day-btn ${activeOption1 === 4 ? "active" : ""}`} onClick={() => handleOptionClick1(4)}>Thứ 5</button>
                                    <button className={`day-btn ${activeOption1 === 5 ? "active" : ""}`} onClick={() => handleOptionClick1(5)}>Thứ 6</button>
                                    <button className={`day-btn ${activeOption1 === 6 ? "active" : ""}`} onClick={() => handleOptionClick1(6)}>Thứ 7</button>
                                    <button className={`day-btn ${activeOption1 === 0 ? "active" : ""}`} onClick={() => handleOptionClick1(0)}>Chủ nhật</button>
                                </div>
                                <div className="lottery-grid">
                                    {dataMT?.map((item, index) => (
                                        <div key={index} className="lottery-card" onClick={() => navigate(`/xsmt/lo2/${item}`)}>
                                            <img className="lottery-img" src={require(`../../images/xs3mien/${imageMT[index]}.png`)} alt={GetCountry(item)} />
                                            <div className="lottery-info">
                                                <div className="lottery-title">{GetCountry(item)}</div>
                                                <div className="play-btn">Vào trò chơi</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}

                        {/* MIỀN NAM */}
                        {activeOption === "2" && (
                            <>
                                <div className="day-nav-bar">
                                    <button className={`day-btn ${activeOption2 === 1 ? "active" : ""}`} onClick={() => handleOptionClick2(1)}>Thứ 2</button>
                                    <button className={`day-btn ${activeOption2 === 2 ? "active" : ""}`} onClick={() => handleOptionClick2(2)}>Thứ 3</button>
                                    <button className={`day-btn ${activeOption2 === 3 ? "active" : ""}`} onClick={() => handleOptionClick2(3)}>Thứ 4</button>
                                    <button className={`day-btn ${activeOption2 === 4 ? "active" : ""}`} onClick={() => handleOptionClick2(4)}>Thứ 5</button>
                                    <button className={`day-btn ${activeOption2 === 5 ? "active" : ""}`} onClick={() => handleOptionClick2(5)}>Thứ 6</button>
                                    <button className={`day-btn ${activeOption2 === 6 ? "active" : ""}`} onClick={() => handleOptionClick2(6)}>Thứ 7</button>
                                    <button className={`day-btn ${activeOption2 === 0 ? "active" : ""}`} onClick={() => handleOptionClick2(0)}>Chủ nhật</button>
                                </div>
                                <div className="lottery-grid">
                                    {dataMN?.map((item, index) => (
                                        <div key={index} className="lottery-card" onClick={() => navigate(`/xsmn/lo2/${item}`)}>
                                            <img className="lottery-img" src={require(`../../images/xs3mien/${imageMN[index]}.png`)} alt={GetCountry(item)} />
                                            <div className="lottery-info">
                                                <div className="lottery-title">{GetCountry(item)}</div>
                                                <div className="play-btn">Vào trò chơi</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}

                        {/* SIÊU TỐC */}
                        {activeOption === "3" && (
                            <div className="lottery-grid">
                                <div className="lottery-card" onClick={() => navigate("/xs75s/lo2")}>
                                    <img className="lottery-img" src={require("../../images/mb75s.png")} alt="Xổ số nhanh 75s" />
                                    <div className="lottery-info">
                                        <div className="lottery-title">Xổ số nhanh 75s</div>
                                        <div className="play-btn">Vào trò chơi</div>
                                    </div>
                                </div>
                                <div className="lottery-card" onClick={() => navigate("/xs120s/lo2")}>
                                    <img className="lottery-img" src={require("../../images/st2p.png")} alt="Xổ số nhanh 120s" />
                                    <div className="lottery-info">
                                        <div className="lottery-title">Xổ số nhanh 120s</div>
                                        <div className="play-btn">Vào trò chơi</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Lottery;